//import module1 from "../assets/training/module1.mp4";
// import module2 from "https://res.cloudinary.com/dbnf8c8jf/video/upload/v1780706844/module2_tfqogt.mp4";
export const modulos = [
  {
    id: 1,
    title: "Módulo 1 - Introducción al Sistema de Formación",
    descripcion: "En este modulo aprenderás como funciona la industria de redes de mercadeo y por que trabajar en la industria.",
    src: "https://res.cloudinary.com/dbnf8c8jf/video/upload/v1784674750/module1_Q5oIDW6n_sgizcn.mp4",
    siguiente: 2,
  },
  {
    id: 2,
    title: "Módulo 2 - Sistema de Duplicación",
    descripcion: "En este modulo aprenderás como duplicar tu negocio.",
    src: "https://res.cloudinary.com/dbnf8c8jf/video/upload/v1780706844/module2_tfqogt.mp4",
  },
];